export function format(str, ...args) {
    let i = 0;
    return str.replace(/{}/g, () => (args[i] !== undefined ? args[i++] : ""));
}

export function underize(str) {
    return str.replace(/ /g, "_");
}

export function capitalize(str) {
    return str.replace(/\w\S*/g, (w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase());
}

export function snakeToTitle(snake) {
    return snake
        .split("_")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(" ");
}
